import qs from "qs";
import axios from "axios";
import { URL } from "../../../../constants/Constants";
import { notify } from "../../../ui/notify";

/**
 * Inserta un nuevo peso en el sistema
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} usuario - Usuario que realiza la operación
 * @param {string} equipo - Equipo del usuario
 * @param {string} selectedOption - Opción seleccionada
 * @param {number} weight - Peso a insertar
 * @param {string} fecha - Fecha de la operación
 * @param {string} selectedDescription - Descripción seleccionada
 * @param {string} tipo_tiempo - Tipo de tiempo
 * @param {number} id - ID de la consulta
 * @param {number} cantidad - Cantidad
 * @returns {Promise<boolean>} true si se guardó correctamente, false en caso contrario
 */
export const insertNewWeight = async (
  po,
  mo,
  usuario,
  equipo,
  selectedOption,
  weight,
  fecha,
  selectedDescription,
  tipo_tiempo,
  id,
  cantidad
) => {
  const newTime = {
    po: po,
    mo: mo,
    usuario: usuario,
    team: equipo,
    selectedOption: selectedOption,
    weight: weight,
    fecha: fecha,
    tipo: selectedDescription,
    tipo_tiempo: tipo_tiempo,
    query_type: id,
    cantidad: cantidad,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Save time");
      return true;
    } else {
      console.log("Error Save time");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene lista de opciones de peso
 * @param {string} mo - Manufacturing Order
 * @param {string} type - Tipo de consulta
 * @param {string} list - Lista
 * @returns {Promise<Array|false>} Lista de opciones de peso o false si hay error
 */
export const getListOptionWeight = async (mo, type, list) => {
  const queryData = {
    code: mo,
    query_type: type,
    list: list,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene el peso total
 * @param {string} mo - Manufacturing Order
 * @param {string} type - Tipo de consulta
 * @param {string} list - Lista
 * @returns {Promise<Array|false>} Peso total o false si hay error
 */
export const getTotalWeight = async (mo, type, list) => {
  const queryData = {
    code: mo,
    query_type: type,
    list: list,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Inserta un nuevo peso intermedio
 * @param {string} po - Purchase Order
 * @param {string} mo - Manufacturing Order
 * @param {string} usuario - Usuario que realiza la operación
 * @param {string} equipo - Equipo del usuario
 * @param {string} selectedOption - Opción seleccionada
 * @param {number} weight - Peso a insertar
 * @param {number} merma - Merma
 * @param {string} fecha - Fecha de la operación
 * @param {string} selectedDescription - Descripción seleccionada
 * @param {string} tipo_tiempo - Tipo de tiempo
 * @param {number} id - ID de la consulta
 * @param {number} cantidad - Cantidad
 * @returns {Promise<boolean>} true si se guardó correctamente, false en caso contrario
 */
export const insertNewIntermediateWeight = async (
  po,
  mo,
  usuario,
  equipo,
  selectedOption,
  weight,
  merma,
  fecha,
  selectedDescription,
  tipo_tiempo,
  id,
  cantidad
) => {
  const newTime = {
    po: po,
    mo: mo,
    usuario: usuario,
    team: equipo,
    selectedOption: selectedOption,
    weight: weight,
    merma: merma,
    fecha: fecha,
    tipo: selectedDescription,
    tipo_tiempo: tipo_tiempo,
    query_type: id,
    cantidad: cantidad,
  };

  try {
    const response = await axios.post(URL, qs.stringify(newTime));

    if (response.data.status === "ok") {
      console.log("Save time");
      return true;
    } else {
      console.log("Error Save time");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Elimina un peso
 * @param {string} typeConnect - Tipo de conexión
 * @param {number} currentScreenId - ID de la pantalla actual
 * @param {string} mo - Manufacturing Order
 * @returns {Promise<boolean>} true si se eliminó correctamente, false en caso contrario
 */
export const deleteWeight = async (typeConnect, currentScreenId, mo) => {
  const queryData = {
    action: typeConnect,
    query_type: currentScreenId,
    mo: mo,
    requestType: "deleteWeight",
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      notify.success("La MO ha sido restaurada");
      return true;
    } else {
      notify.error("Error al restaurar la MO");
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
